import React from 'react';

import { FormItem, Input } from '../../../components';
import type { AgentForm as AgentFormType } from '../../../utilities';
import {
  FALLBACK_FIELD_NAMES,
  type FallbackKind,
} from '../utils/fallbackSettings';
import { makeIntRangeValidator, makeRangeValidator } from '../utils/validators';

const LABELS: Record<
  FallbackKind,
  { attemptTimeout: string; maxRetry: string; retryInterval: string }
> = {
  stt: {
    attemptTimeout: 'Fallback attempt timeout (seconds)',
    maxRetry: 'Fallback max retries per STT',
    retryInterval: 'Fallback retry interval (seconds)',
  },
  tts: {
    attemptTimeout: 'Fallback attempt timeout (seconds)',
    maxRetry: 'Fallback max retries per TTS',
    retryInterval: 'Fallback retry interval (seconds)',
  },
};

export type FallbackSettingsFieldsProps = {
  kind: FallbackKind;
  disabled?: boolean;
};

export const FallbackSettingsFields: React.FC<FallbackSettingsFieldsProps> = ({
  kind,
  disabled,
}) => {
  const fields = FALLBACK_FIELD_NAMES[kind];
  const labels = LABELS[kind];

  return (
    <>
      <FormItem<AgentFormType>
        name={fields.attempt_timeout}
        label={labels.attemptTimeout}
        validate={makeRangeValidator(0.01, 300, 'seconds')}
      >
        <Input numeric roundTo={2} disabled={disabled} />
      </FormItem>
      <FormItem<AgentFormType>
        name={fields.max_retry}
        label={labels.maxRetry}
        validate={makeIntRangeValidator(1, 100)}
      >
        <Input numeric roundTo={0} disabled={disabled} />
      </FormItem>
      <FormItem<AgentFormType>
        name={fields.retry_interval}
        label={labels.retryInterval}
        validate={makeRangeValidator(0.01, 60, 'seconds')}
      >
        <Input numeric roundTo={2} disabled={disabled} />
      </FormItem>
    </>
  );
};
